var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03887 5.46637L7.00743 5H6.54H5.03H4.49475L4.53116 5.53401C4.62414 6.89767 4.89282 8.21058 5.31685 9.45166L5.57625 10.2109L6.14355 9.64355L7.34355 8.44355L7.55234 8.23476L7.47032 7.95111C7.24074 7.15715 7.09659 6.32255 7.03887 5.46637ZM16.5359 17.0388L16.2551 16.9595L16.0479 17.165L14.8479 18.355L14.2692 18.9289L15.0431 19.1847C16.291 19.5973 17.6022 19.8659 18.966 19.9588L19.5 19.9953V19.46V17.97V17.5029L19.034 17.4712C18.1882 17.4135 17.3523 17.2694 16.5359 17.0388ZM16.2443 15.9042L16.2586 15.9099L16.2732 15.9148C17.4436 16.3014 18.7066 16.51 20 16.51C20.2739 16.51 20.5 16.7361 20.5 17.01V20.5C20.5 20.7739 20.2739 21 20 21C10.8861 21 3.5 13.6139 3.5 4.5C3.5 4.22614 3.72614 4 4 4H7.5C7.77386 4 8 4.22614 8 4.5C8 5.80213 8.20815 7.05368 8.5939 8.2228C8.6492 8.40217 8.6082 8.59469 8.46645 8.73645L6.26645 10.9364L6.00972 11.1932L6.17437 11.5168C7.66275 14.4418 10.0595 16.8276 12.982 18.325L13.3061 18.491L13.5636 18.2336L15.7584 16.0387C15.8677 15.9366 15.994 15.89 16.12 15.89C16.1541 15.89 16.1818 15.8918 16.2043 15.895C16.2268 15.8982 16.2392 15.9022 16.2443 15.9042Z",
    fill: "#2C333A",
    stroke: "#00838F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.65b938694324d80164a1842745762be0.svg";
export { ForwardRef as ReactComponent };